<template>
    <div>
        <Loading :active="loading" :is-full-page="true" />
        <div align="center" justify="center" class="pa-3">
            <v-card align="left" justify="left" class="mb-3">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-icon class="primary--text lighten-2 pa-2">
                        mdi-tag-multiple-outline
                    </v-icon>
                    Administração > Manutenção de Espécies de Títulos
                </v-card-text>
            </v-card>

            <v-card class="pa-3">
                <v-card-actions class="pb-0">
                    <v-btn
                        color="primary"
                        :disabled="loading"
                        @click="abrirModalNovaEspecie"
                        data-cy="btnNovaEspecie"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Nova Espécie de Título
                    </v-btn>
                </v-card-actions>

                <v-data-table
                    :headers="headers"
                    :items="especies"
                    :loading="loading"
                    :footer-props="{
                        itemsPerPageOptions: [10, 20, 50, 100],
                        itemsPerPageText: 'Itens por página:'
                    }"
                    item-key="cd_especie_titulo"
                    class="elevation-1 mt-2"
                    :server-items-length="totalItems"
                    :page.sync="currentPage"
                    :items-per-page.sync="itemsPerPage"
                    @update:page="carregarDados"
                    @update:items-per-page="carregarDados"
                >
                    <template v-slot:[`item.requer_anexo`]="{ item }">
                        <v-chip
                            :color="item.requer_anexo ? 'success' : 'default'"
                            small
                            outlined
                        >
                            {{ item.requer_anexo ? 'Sim' : 'Não' }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.acoes`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    small
                                    color="primary"
                                    @click="abrirModalEdicao(item)"
                                    data-cy="btnEditar"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <ModalEspecieTitulo
            v-if="modalAtivo"
            :showModal="modalAtivo"
            :especie="especieSelecionada"
            @fecharModal="fecharModal"
            @mostrarMensagem="mostrarMensagem"
            @atualizarLista="carregarDados"
        />

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="5000"
            top
            right
        >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import EspecieTituloService from '@/services/EspecieTituloService';
import ModalEspecieTitulo from '@/modals/ModalEspecieTitulo.vue';
import Loading from 'vue-loading-overlay';

export default {
    name: 'ManutencaoEspecieTitulos',
    components: {
        ModalEspecieTitulo,
        Loading
    },
    data() {
        return {
            loading: false,
            especies: [],
            modalAtivo: false,
            especieSelecionada: null,
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'success',
            currentPage: 1,
            itemsPerPage: 20,
            totalItems: 0,
            headers: [
                {
                    text: 'Código',
                    value: 'cd_especie_titulo',
                    sortable: true
                },
                {
                    text: 'Nome',
                    value: 'nm_especie_titulo',
                    sortable: true
                },
                {
                    text: 'Descrição Complementar',
                    value: 'ds_complementar_especie_titulo',
                    sortable: false
                },
                {
                    text: 'Requer Anexo',
                    value: 'requer_anexo',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Ações',
                    value: 'acoes',
                    sortable: false,
                    align: 'center',
                    width: '80px'
                }
            ]
        };
    },
    async mounted() {
        await this.carregarDados();
    },
    methods: {
        async carregarDados() {
            this.loading = true;
            try {
                const service = new EspecieTituloService(
                    this.$http,
                    this.$store
                );
                const params = {
                    page: this.currentPage,
                    per_page: this.itemsPerPage
                };

                const response = await service.listarEspecies(params);
                this.especies = response.results;
                this.totalItems = response.total_results;
            } catch (error) {
                this.mostrarMensagem('Erro ao carregar espécies de títulos', 'error');
                console.error('Erro ao carregar dados:', error);
            } finally {
                this.loading = false;
            }
        },

        abrirModalNovaEspecie() {
            this.especieSelecionada = null;
            this.modalAtivo = true;
        },

        abrirModalEdicao(item) {
            this.especieSelecionada = { ...item };
            this.modalAtivo = true;
        },

        fecharModal() {
            this.modalAtivo = false;
            this.especieSelecionada = null;
        },

        mostrarMensagem(mensagem, tipo = 'success') {
            this.snackbarMessage = mensagem;
            this.snackbarColor = tipo;
            this.snackbar = true;
        }
    }
};
</script>
